import React from 'react'
import Responsive from '../../assets/config/Responsive'
import CloudIcon from '../../assets/v2/JSX/CloudIcon'
import styled from 'styled-components'
import ShortKiteIcon from '../../assets/icons/JSX/ShortKiteIcon'

const BackgroundIcon: React.FC<{
  shortKite?: boolean
}> = ({ shortKite = false }) => {
  return (
    <>
      <KiteIconStyle $shortKite={shortKite}/>
      <CloudIconStyle />
    </>
  )
}

const KiteIconStyle = styled(ShortKiteIcon)<{$shortKite: boolean}>`
  position: fixed;
  bottom: ${({$shortKite}) => $shortKite === true ? '-35px' : '0px'};
  right: 40px;
  user-select: none;
  pointer-events: none;
  ${Responsive.tablet}{
    right: 10px;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const CloudIconStyle = styled(CloudIcon)`
  position: fixed;
  left: 100px;
  bottom: 10px;
  user-select: none;
  pointer-events: none;
  ${Responsive.tablet} {
    left: 65px;
  }
  ${Responsive.mobile} {
    display: none;
  }
`

export default BackgroundIcon
